import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsLvtSounds extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
